import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { useProjectData } from "@/hooks/useProjectData";

export function ValidationBanner() {
	const { t } = useTranslation();
	const { slug } = useParams<{ slug: string }>();
	const { report } = useProjectData();

	const errors = report.errors.length;
	const warnings = report.warnings.length;

	if (errors === 0 && warnings === 0) {
		return (
			<div
				className="flex items-center gap-2 px-4 py-1.5 text-[12px]"
				style={{
					background: "rgba(34, 197, 94, 0.08)",
					borderBottom: "1px solid rgba(34, 197, 94, 0.15)",
					color: "#4ade80",
				}}
			>
				<CheckCircle2 size={14} />
				<span>{t("validationBanner.ready")}</span>
			</div>
		);
	}

	if (errors > 0) {
		return (
			<div
				className="flex items-center gap-2 px-4 py-1.5 text-[12px]"
				style={{
					background: "rgba(239, 68, 68, 0.08)",
					borderBottom: "1px solid rgba(239, 68, 68, 0.2)",
					color: "#f87171",
				}}
			>
				<XCircle size={14} />
				<span className="font-semibold">
					{t("validationBanner.errors", { count: errors })}
				</span>
				{warnings > 0 && (
					<span style={{ opacity: 0.7 }}>
						· {t("validationBanner.warningsShort", { count: warnings })}
					</span>
				)}
				<Link
					to={`/projects/${slug}/validation`}
					className="ml-auto underline hover:no-underline"
				>
					{t("validationBanner.viewReport")}
				</Link>
			</div>
		);
	}

	return (
		<div
			className="flex items-center gap-2 px-4 py-1.5 text-[12px]"
			style={{
				background: "rgba(245, 158, 11, 0.08)",
				borderBottom: "1px solid rgba(245, 158, 11, 0.2)",
				color: "#fbbf24",
			}}
		>
			<AlertTriangle size={14} />
			<span>
				{t("validationBanner.warnings", { count: warnings })}
			</span>
			<Link
				to={`/projects/${slug}/validation`}
				className="ml-auto underline hover:no-underline"
			>
				{t("validationBanner.viewReport")}
			</Link>
		</div>
	);
}
